import { Link } from '@/components/ui'
import { cn } from '@/lib/utils'
import type { IconType } from './navigation'

/**
 * A single nav link in the Collectia-Blue sidebar. White text on blue, subtle
 * white hover, and a turquoise accent (left bar + icon) on the current item —
 * per docs/DESIGN_GUIDELINES.md §6. Built on the Inertia-wired Link primitive.
 */
export function SidebarNavItem({
  href,
  icon: Icon,
  label,
  current,
}: {
  href: string
  icon: IconType
  label: string
  current: boolean
}) {
  return (
    <Link
      href={href}
      aria-current={current ? 'page' : undefined}
      className={cn(
        'group relative flex items-center gap-3 rounded-control px-3 py-2.5 text-sm font-medium transition-colors',
        current ? 'bg-white/10 text-white' : 'text-white/80 hover:bg-white/5 hover:text-white',
      )}
    >
      {current && (
        <span aria-hidden="true" className="absolute inset-y-1.5 left-0 w-1 rounded-full bg-brand-turquoise" />
      )}
      <Icon
        aria-hidden="true"
        className={cn(
          'size-5 shrink-0 transition-colors',
          current ? 'text-brand-turquoise' : 'text-white/70 group-hover:text-white',
        )}
      />
      <span className="truncate">{label}</span>
    </Link>
  )
}
